import { Suspense, useMemo } from "react";
import GetComponent from "./GetComponent";
import { useLazyOnView } from "./LazyLoad";

const GetSectionByType = ({
  sectionData,
  isLogin,
  setIsModalOpenoffer,
  isModalOpenoffer,
  setShowModal,
  setIsLoading,
  Loading,
  showModal,
  isMobileView,
  unlockData,
  setCustomeLoader,
  isMyAccountPage
}) => {
  // Memoize the props object to avoid unnecessary re-renders
  const componentProps = useMemo(() => {
    return {
      sectionData,
      isLogin,
      setIsModalOpenoffer,
      isModalOpenoffer,
      setShowModal,
      setIsLoading,
      Loading,
      showModal,
      isMobileView,
      unlockData,
      setCustomeLoader,
      isMyAccountPage
    };
  }, [
    sectionData,
    isLogin,
    setIsModalOpenoffer,
    isModalOpenoffer,
    setShowModal,
    unlockData,
    setIsLoading,
    Loading,
    showModal,
    isMobileView,
    setCustomeLoader,
    isMyAccountPage
  ]);

  // Only render the component when visible
  return (
    <Suspense fallback={<div style={{ height: 300 }} />}>
      <GetComponent {...componentProps} />
    </Suspense>
  );
};

export default GetSectionByType;
